import request from '@/utils/request'

// 分页查询
export function pageSysVersionInfo(params) {
  return request({
    url: '/v3/manager/appVersionInfo/pageSysVersionInfo',
    method: 'post',
    data: params
  })
}
export function save(params) {
  return request({
    url: '/v3/manager/appVersionInfo/save',
    method: 'post',
    data: params
  })
}
export function deleteById(params) {
  return request({
    url: '/v3/manager/appVersionInfo/deleteById',
    method: 'post',
    data: params
  })
}
export function list(params) {
  return request({
    url: '/v3/manager/appCenter/list',
    method: 'get',
    data: params
  })
}
// 上传文件
export function upload(params) {
  var formData = new FormData()
  formData.append('multipartFile', params.raw)
  return request({
    url: '/v3/manager/appCenter/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
export function add(params) {
  return request({
    url: '/v3/manager/appCenter/add',
    method: 'post',
    data: params
  })
}
export function updateById(params) {
  return request({
    url: '/v3/manager/appCenter/updateById',
    method: 'post',
    data: params
  })
}
export function deleteAppById(params) {
  return request({
    url: '/v3/manager/appCenter/deleteById',
    method: 'post',
    data: params
  })
}
